const steps = [
  { num: '1', title: 'Диагностика', desc: 'Изучаем реальные управленческие ситуации и проблемы компании: как сейчас ставятся задачи, как происходит делегирование, где возникают сложности с контролем и самостоятельностью сотрудников.' },
  { num: '2', title: 'Настройка программы', desc: 'Адаптируем обучение под уровень руководителей и актуальные задачи бизнеса. Корректируем содержание, примеры и акценты под реальный управленческий контекст компании.' },
  { num: '3', title: 'Практическое обучение', desc: 'Разбираем постановку задач, делегирование и контроль на конкретных ситуациях из практики участников. Не абстрактные модели, а реальные управленческие задачи.' },
  { num: '4', title: 'Отработка', desc: 'Участники тренируются ставить задачи, передавать ответственность и проводить контрольные разговоры. Ролевые ситуации, разбор кейсов, упражнения на проверку понимания задач.' },
  { num: '5', title: 'Внедрение', desc: 'Инструменты делегирования и постановки задач переносятся в ежедневную управленческую практику. Участники получают алгоритмы и чек-листы для использования в работе.' },
  { num: '6', title: 'Сопровождение', desc: 'При необходимости разбираем реальные ситуации после обучения: что получилось внедрить, где возникли сложности, как скорректировать подход к конкретным сотрудникам.' },
];

export default function HowTrainingWorks() {
  return (
    <section id="process" className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Как проходит обучение
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          От диагностики до сопровождения: шесть этапов, которые обеспечивают реальное изменение управленческих привычек
        </p>

        <div className="relative">
          <div className="hidden lg:block absolute left-[23px] top-8 bottom-8 w-0.5 bg-teal-200"></div>
          <div className="space-y-6">
            {steps.map((step) => (
              <div key={step.num} className="flex gap-5 items-start relative">
                <div className="w-12 h-12 rounded-full bg-teal-600 text-white flex items-center justify-center text-lg font-bold flex-shrink-0 z-10">
                  {step.num}
                </div>
                <div className="bg-gray-50 rounded-xl border border-gray-200 p-4 md:p-5 flex-1 hover:border-teal-300 transition-colors">
                  <h3 className="font-bold text-gray-900 text-sm mb-1.5">{step.title}</h3>
                  <p className="text-gray-600 text-xs leading-relaxed">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}